export default __webpack_public_path__ + "media/images/banner/banner-5-dd70a36f8b27d2abb178e7687f960f1e.jpg";